import { useState } from "react";

/**
 * Manages entity selection and editing state
 * Handles: selectedItems, editingItem, deletingItem, modals, export state
 */
export function useEntityState<T>() {
  const [selectedItems, setSelectedItems] = useState<T[]>([]);
  const [editingItem, setEditingItem] = useState<T | null>(null);
  const [deletingItem, setDeletingItem] = useState<T | null>(null);
  const [showComposeModal, setShowComposeModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [bulkEmailExportData, setBulkEmailExportData] = useState<{
    emailList: string;
    totalCount: number;
  } | null>(null);

  return {
    selectedItems,
    setSelectedItems,
    editingItem,
    setEditingItem,
    deletingItem,
    setDeletingItem,
    showComposeModal,
    setShowComposeModal,
    showExportModal,
    setShowExportModal,
    isExporting,
    setIsExporting,
    exportProgress,
    setExportProgress,
    bulkEmailExportData,
    setBulkEmailExportData,
  };
}
